import { DataProvider, Identifier } from 'react-admin';
import {
    COMPANY_CREATED,
    CONTACT_CREATED,
    CONTACT_NOTE_CREATED,
    DEAL_CREATED,
    DEAL_NOTE_CREATED,
} from '../../consts';
import {
    Activity,
    Supplier,
    Contact,
    ContactNote,
    PurchaseOrder,
    DealNote,
} from '../../types';

// FIXME: Requires 5 large queries to get the latest activities.
// Replace with a server-side view or a custom API endpoint.
export async function getActivityLog(
    dataProvider: DataProvider,
    supplierID?: Identifier,
    salesId?: Identifier
) {

    let supplierFilter = {} as any;
    if (supplierID) {
        supplierFilter.id = supplierID;
    } else if (salesId) {
        supplierFilter.id_vendedor = salesId;
    }
    supplierFilter.dias_cadastro = 30;

    let filter = {} as any;
    if (supplierID) {
        filter.id_pessoa = supplierID;
    } else if (salesId) {
        filter.id_vendedor = salesId;
    }

    const [newCustomers, newContactsAndNotes, newDealsAndNotes] =
        await Promise.all([
            getNewSuppliers(dataProvider, supplierFilter),
            getNewContactsAndNotes(dataProvider, filter),
            getNewDealsAndNotes(dataProvider, filter),
        ]);

    return (
        [...newCustomers, ...newContactsAndNotes, ...newDealsAndNotes]
            // sort by date desc
            .sort((a, b) =>
                a.date && b.date ? a.date.localeCompare(b.date) * -1 : 0
            )
            // limit to 250 activities
            .slice(0, 250)
    );
}

const getNewSuppliers = async (
    dataProvider: DataProvider,
    filter: any
): Promise<Activity[]> => {
    const { data: clientes } = await dataProvider.getList<Supplier>(
        'suppliers',
        {
            filter,
            pagination: { page: 1, perPage: 20 },
            sort: { field: 'data_cadastro', order: 'DESC' },
        }
    );
    return clientes.map(company => ({
        id: `company.${company.id}.created`,
        type: COMPANY_CREATED,
        id_pessoa: company.id,
        company,
        criado_por: company.criado_por,
        data_cadastro: company.data_cadastro,
        date: company.data_cadastro,
    }));
};

async function getNewContactsAndNotes(
    dataProvider: DataProvider,
    filter: any
): Promise<Activity[]> {
    return [];
    const { data: contacts } = await dataProvider.getList<Contact>('suppliercontacts', {
        filter,
        pagination: { page: 1, perPage: 20 },
        sort: { field: 'data_hora', order: 'DESC' },
    });

    let recentContactNotesFilter = {} as any;
    if (filter.sales_id) {
        recentContactNotesFilter.sales_id = filter.sales_id;
    }
    if (filter.id_pessoa) {
        recentContactNotesFilter.id_pessoa = filter.id_pessoa;
    }

    const { data: contactNotes } = await dataProvider.getList<ContactNote>(
        'customernotes',
        {
            filter: recentContactNotesFilter,
            pagination: { page: 1, perPage: 20 },
            sort: { field: 'data_hora', order: 'DESC' },
        }
    );

    const newContacts = contacts.map(contact => ({
        id: `contact.${contact.id}.created`,
        type: CONTACT_CREATED,
        id_pessoa: contact.id_pessoa,
        cod_vendedor: contact.cod_vendedor,
        contact,
        data_hora: contact.data_hora,
        date: contact.data_hora,
    }));

    const newContactNotes = contactNotes.map(contactNote => ({
        id: `contactNote.${contactNote.id}.created`,
        type: CONTACT_NOTE_CREATED,
        sales_id: contactNote.id_contato,
        contactNote,
        data_hora: contactNote.data_hora,
        date: contactNote.data_hora,
    }));

    return [...newContacts, ...newContactNotes];
}

async function getNewDealsAndNotes(
    dataProvider: DataProvider,
    filter: any
): Promise<Activity[]> {
    const { data: ocs } = await dataProvider.getList<PurchaseOrder>('purchaseorders', {
        filter,
        pagination: { page: 1, perPage: 20 },
        sort: { field: 'dthr_agendamento', order: 'DESC' },
    });

    let recentDealNotesFilter = { modulo: "SCM" } as any;
    if (filter.sales_id) {
        recentDealNotesFilter.sales_id = filter.sales_id;
    }
    if (filter.id_pessoa) {
        recentDealNotesFilter['id_pessoa'] = filter.id_pessoa;
    }

    const { data: dealNotes } = await dataProvider.getList<DealNote>(
        'dealnotes',
        {
            filter: recentDealNotesFilter,
            pagination: { page: 1, perPage: 20 },
            sort: { field: 'data_hora', order: 'DESC' },
        }
    );

    const newDeals = ocs.map(deal => ({
        id: `deal.${deal.id}.created`,
        type: DEAL_CREATED,
        id_pessoa: deal.id_pessoa,
        id_vendedor: deal.id_vendedor,
        deal,
        data_hora: deal.data_hora,
        date: deal.data_hora,
    }));

    const newDealNotes = dealNotes.map(dealNote => ({
        id: `dealNote.${dealNote.id}.created`,
        type: DEAL_NOTE_CREATED,
        id_vendedor: dealNote.id_vendedor,
        dealNote,
        data_hora: dealNote.data_hora,
        date: dealNote.data_hora,
    }));

    return [...newDeals, ...newDealNotes];
}
